export const ROLES_REQUEST = "ROLES_REQUEST";
export const ROLES_REQUEST_SUCCEEDED = "ROLES_REQUEST_SUCCEEDED";
export const ROLES_REQUEST_FAILED = "ROLES_REQUEST_FAILED";
